import React from "react";

const ClientContainer = () => {
  const clients = [
    {
      image: "https://randomuser.me/api/portraits/women/44.jpg",
      name: "Sarah Johnson",
      service: "E-commerce Website"
    },
    {
      image: "https://randomuser.me/api/portraits/men/32.jpg",
      name: "Michael Chen",
      service: "Mobile App Development"
    },
    {
      image: "https://randomuser.me/api/portraits/women/68.jpg",
      name: "Priya Patel",
      service: "UI/UX Design"
    },
    {
      image: "https://randomuser.me/api/portraits/men/75.jpg",
      name: "David Wilson",
      service: "Web Application"
    },
    {
      image: "https://randomuser.me/api/portraits/women/65.jpg",
      name: "Emma Rodriguez",
      service: "SEO Optimization"
    },
    {
      image: "https://randomuser.me/api/portraits/men/85.jpg",
      name: "James Wilson",
      service: "Brand Identity"
    },
    {
      image: "https://randomuser.me/api/portraits/women/33.jpg",
      name: "Sophia Kim",
      service: "CMS Development"
    },
    {
      image: "https://randomuser.me/api/portraits/men/22.jpg",
      name: "Robert Taylor",
      service: "API Integration"
    }
  ];

  return (
    <section className="py-10 px-4 lg:px-12 bg-gray-50">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
          {clients.map((client, index) => (
            <div 
              key={index}
              className="bg-white p-5 rounded-lg shadow-md flex flex-col items-center text-center"
            >
              <img 
                src={client.image} 
                alt={client.name}
                className="w-20 h-20 rounded-full object-cover mb-4 border-2 border-white shadow-md"
              />
              <h3 className="font-semibold text-gray-900">{client.name}</h3>
              <p className="text-sm text-blue-600 mt-1 bg-blue-50 px-3 py-1 rounded-full">
                {client.service}
              </p>
            </div>
          ))}
      </div>
    </section>
  );
};

export default ClientContainer;